import { useSelector } from 'react-redux';

const useAgencyNotifications = (placement) => useSelector((state) => {
  if (!placement) return [];

  const { travelAgency } = state.user;
  const notifications = travelAgency?.agencyNotifications || [];

  if (!notifications || !Array.isArray(notifications) || notifications.length === 0) return [];

  const dismissed = state.user.userPreferences?.dismissedNotifications || [];

  const isDismissed = (id) => dismissed.some((d) => d.id === id && d.placement === placement);

  return notifications.filter((n) => n.placements?.includes(placement) && !isDismissed(n.id));
});

export default useAgencyNotifications;
